import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Autocomplete,
  CircularProgress,
  TextField,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  FormControlLabel,
  Checkbox,
  Chip,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SubHeader from "../../../../components/SubHeader";
import AttendanceList from "./AttendanceList";
import GroupResultView from "./GroupResultView";
import styles from "./style";
import male from "../../../../assets/images/male.png";
import Modal from "../../../../components/Modal";
import { formatFormDate } from "../../../../utils/DateFormat";
import { getDateFormat } from "../../../../utils/dateFormatStore";
import { ReactComponent as Download } from "../../../../assets/invoice/blueDownload.svg";
import DragAndDropInput from "../../../../components/DragAndDropInput";
import moment from "moment-timezone";
import AuthService from "../../../../api/AuthService";
import { attendanceService } from "../../../../api";
import { useAlert } from "../../../../context/AlertContext";

// ------------------------------------------------------------------------------------------------
// Main attendance page
// ------------------------------------------------------------------------------------------------

const AttendancePage = ({
  data,
  note,
  setNote,
  handleCheckIn,
  handleCheckout,
  open,
  opens,
  setOpens,
  setOpen,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  page,
  total,
  setPage,
  handleSort,
  handleApi,
  handleDelete,
  handleSearch,
  handleFilter,
  loading,
  SearchEmployee,
  EmployeeData,
  setEmployeeData,
  employeeCheckeIn,
  getcheckedInEmployee,
  permission,
  role,
  handleExport,
  profileState,
  handleImport,
  markAbsent,
  handleCheckHoliday,
  setHolidayOpen,
  popupMsg,
  holidayOpen,
  from,
  setFrom
}) => {
  const employeeIds = localStorage.getItem("employeeId");
  const [error, setError] = useState("");
  const [checkInTime, setCheckInTime] = useState("");
  const [checkinDate, setCheckinDate] = useState(formatFormDate(new Date()));
  const [checkinEndDate, setCheckinEndDate] = useState(
    formatFormDate(new Date())
  );
  const { showAlert } = useAlert();
  // Employees picked in the Check In / Check Out popup, and the optional cost centre that added them
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [costCentre, setCostCentre] = useState("");
  const [departments, setDepartments] = useState([]);
  const [skippedAutomatic, setSkippedAutomatic] = useState(0);
  const [costCentreLoading, setCostCentreLoading] = useState(false);
  const [groupResult, setGroupResult] = useState(null);
  const [groupLoading, setGroupLoading] = useState(false);
  const [importOpen, setImportOpen] = useState(false);
  const [includeNonScheduledDays, setIncludeNonScheduledDays] = useState(false);
  const [status, setStatus] = useState("Status");
  const employee = localStorage.getItem("employeeId");
  const [fromDates, setFromDates] = useState(dayjs());
  const [toDates, setToDates] = useState(dayjs());
  const [email, setEmail] = useState();
  const [type, setType] = useState();
  const [img, setImg] = useState();
  const [emailError, setEmailError] = useState("");

  useEffect(() => {
    if (opens) {
      resetExportModalFields();
    }
  }, [opens]);

  useEffect(() => {
    if (!open) return;
    setSelectedEmployees([]);
    setCostCentre("");
    setGroupResult(null);
    setSkippedAutomatic(0);
    setCheckInTime("");
    setError("");
    setCheckinDate(formatFormDate(new Date()));
    setCheckinEndDate(formatFormDate(new Date()));
    setIncludeNonScheduledDays(false);
    if (!isPreAttendance) {
      handleAttendanceSearch(from, "");
      AuthService.getDepartment()
        .then((res) => {
          if (res?.success) setDepartments(res.data?.position || []);
        })
        .catch(() => {});
    }
  }, [open]);

  const applyRequest = () => {
    handleExport(email, fromDates, toDates, type);
  };
  const applyFile = (img) => {
    handleImport(img);
    setImportOpen(false);
  };

  const handleAttendanceSearch = (from, value) => {
    if (from === "checkIn") {
      SearchEmployee(value);
    } else {
      getcheckedInEmployee(value);

    }
  };

  // Picking a cost centre adds its employees to the selection (like Payroll); chips can still be removed.
  // "All" adds every employee. Employees with automatic attendance are never added.
  const handleCostCentre = async (value) => {
    setCostCentre(value);
    if (!value) return;
    setCostCentreLoading(true);
    try {
      const res = await attendanceService.groupEmployees(value === "All" ? "" : value, "", true);
      if (res?.success) {
        const list = res.data?.employees || [];
        setSkippedAutomatic(res.data?.skippedAutomatic || 0);
        setSelectedEmployees((prev) => {
          const known = new Set(prev.map((e) => e._id));
          return [...prev, ...list.filter((e) => !known.has(e._id))];
        });
      } else {
        showAlert(res?.message || "Could not load employees", "error");
      }
    } catch (e) {
      // handled by the global interceptor
    } finally {
      setCostCentreLoading(false);
    }
  };

  // One time for every selected employee
  const submitGroup = async () => {
    const [h, m] = checkInTime.split(":");
    setGroupLoading(true);
    try {
      const payload = {
        employees: selectedEmployees.map((e) => ({ employeeId: e._id })),
        date: checkinDate,
        endDate: checkinEndDate,
        time: `${h.padStart(2, "0")}:${m}`,
        timezone: moment.tz.guess(),
        includeNonScheduledDays,
      };
      const res =
        from === "checkIn"
          ? await attendanceService.groupCheckin(payload)
          : await attendanceService.groupCheckout(payload);
      if (res?.success) {
        setGroupResult(res.data);
        showAlert(res.message, "success");
        handleApi("", "", fromDate, toDate, "", "", page);
      } else {
        showAlert(res?.message || "Something went wrong", "error");
      }
    } catch (e) {
      // handled by the global interceptor
    } finally {
      setGroupLoading(false);
    }
  };

  const handleAttendance = () => {
    if (isGroupAction) {
      submitGroup();
      return;
    }
    if (from === "checkIn") {
      handleCheckIn(checkInTime, checkinDate, checkinEndDate, employeeId, includeNonScheduledDays);
    } else {
      handleCheckout(checkInTime, checkinDate, checkinEndDate, employeeId, includeNonScheduledDays);
    }
    setCheckInTime("");
    setCheckinDate(formatFormDate(new Date()));
    setCheckinEndDate(formatFormDate(new Date()));

    setSelectedEmployees([]);
    setCostCentre("");
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };
  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    validateEmail(newEmail);
  };

  const handleChange = (value) => {
    setCheckInTime(value);
    if (!/^([01]?[0-9]|2[0-3]):([0-5][0-9])$/.test(value)) {
      setError("Invalid time format(hh:mm)");
    }
    else {
      setError("");
    }
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isEmployeeRole = role === "Employee" || role === "employee";
  const openMenu = Boolean(anchorEl);
  
  const isPreAttendance =
    profileState[0]?.additionalInformation?.isPreAttendance;
  
  const hasEditAllPermission = permission?.attendance?.isEdit === true;
  const hasEditOwnPermission = permission?.attendance?.isEditOwn === true;
  const hasEditDepartmentPermission = permission?.attendance?.isEditDepartment === true;
  const hasViewPermission = permission?.attendance?.isView === true;
  const canManageAttendance = hasEditAllPermission || hasEditOwnPermission || hasEditDepartmentPermission;
  const canCheckInOut = canManageAttendance || role === "Admin" || role === "SuperAdmin" || isPreAttendance;
  const showCheckInOutButtons = role === "Admin" || role === "SuperAdmin" || canManageAttendance || isPreAttendance;
  const usesSelfAttendanceAction = isEmployeeRole && !hasEditAllPermission && !hasEditDepartmentPermission;
  // A cost centre or several employees => group action (skips existing records and automatic-attendance staff).
  // Exactly one employee => the existing single check-in/out, which can still adjust any one person.
  const employeeId = isPreAttendance
    ? employeeIds
    : selectedEmployees.length === 1
    ? selectedEmployees[0]._id
    : "";
  const isGroupAction = !isPreAttendance && (costCentre !== "" || selectedEmployees.length > 1);
  const noSelection = !isPreAttendance && selectedEmployees.length === 0;
  const holidayEmail =
    selectedEmployees.length === 1
      ? selectedEmployees[0]?.personalInfo?.email || selectedEmployees[0]?.employee?.personalInfo?.email
      : email;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleStatus = (status) => {
    if (status === "All") {
      handleApi("", "", fromDate, toDate, "", "", page);
      setStatus("Status");
    } else {
      setStatus(status);
      handleApi("", "", fromDate, toDate, status, "", page);
    }

    handleClose();
  };
  const handleAdminCheckin = (text) => {
    setOpen(true);
    setFrom(text);
  };

  // If a employee checkin with only view permissions
  const handleEmployeeCheckIn = () => {
    const time = dayjs().format("HH:mm");
    const date = dayjs().format("YYYY-MM-DD");
    handleCheckIn(time, date, date, employee);
  };

  const handleEmployeeCheckOut = () => {
    const time = dayjs().format("HH:mm");
    const date = dayjs().format("YYYY-MM-DD");
    handleCheckout(time, date, date, employee);
  };

  const resetExportModalFields = () => {
    setEmail("");
    setFromDates(dayjs());
    setToDates(dayjs());
    setType("");
    setEmailError("");
  };

  return (
    <>
      <Box
        px="15px"
        pt="20px"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap={{ xs: "wrap", md: "nowrap" }}
        gap={"10px"}
      >
        <Typography sx={styles.heading}>
          {isEmployeeRole ? "My Attendance" : "Attendance"}
        </Typography>

        <Box
          display="flex"
          justifyContent={{ xs: "start", md: "end" }}
          alignItems={{ xs: "center", md: "end" }}
          flexWrap={{ xs: "wrap", md: "nowrap" }}
          gap={"10px"}
        >
          {showCheckInOutButtons && (
            <>
              <Button
                variant="contained"
                color="success"
                sx={styles.checkinBtn}
                disabled={!canCheckInOut}
                onClick={() => {
                  if (role === "Admin" || role === "SuperAdmin" || hasEditAllPermission || hasEditDepartmentPermission) {
                    handleAdminCheckin("checkIn");
                  } else {
                    handleEmployeeCheckIn();
                  }
                }}
              >
                {"Check In"}
              </Button>
              <Button
                variant="contained"
                color="success"
                sx={styles.checkoutBtn}
                disabled={!canCheckInOut ? true : (usesSelfAttendanceAction && !employeeCheckeIn)}
                onClick={() => {
                  // Open the managed-attendance modal for Admin/SuperAdmin, all, and department attendance editors.
                  // For hasEditOwnPermission (Can Edit Self) -> direct employee check-out without modal
                  if (role === "Admin" || role === "SuperAdmin" || hasEditAllPermission || hasEditDepartmentPermission) {
                    handleAdminCheckin("checkOut");
                  } else {
                    handleEmployeeCheckOut();
                  }
                }}
              >
                {"Check Out"}
              </Button>
            </>
          )}
          {(hasEditAllPermission || role === "Admin" || role === "SuperAdmin") && (
            <>
              <Button
                sx={styles.exportBtn}
                onClick={() => {
                  setImportOpen(true);
                }}
              >
                <Download />
                Import
              </Button>
              <Button
                sx={styles.exportBtn}
                onClick={() => {
                  setOpens(true);
                }}
              >
                <Download />
                Export
              </Button>
            </>
          )}
        </Box>
      </Box>
      <Box sx={styles.mainSection}>
        <SubHeader
          title={isEmployeeRole ? "My Attendance" : "Attendance Today"}
          isShow={false}
          isShowFilter={hasViewPermission || canManageAttendance || role === "Admin" || role === "SuperAdmin"}
          btn={hasEditAllPermission || role === "Admin" || role === "SuperAdmin"}
          search={hasViewPermission || canManageAttendance || role === "Admin" || role === "SuperAdmin"}
          sortBy={hasViewPermission || canManageAttendance || role === "Admin" || role === "SuperAdmin"}
          onchange={handleSearch}
          filter={handleFilter}
          toDate={toDate}
          setToDate={setToDate}
          setFromDate={setFromDate}
          fromDate={fromDate}
          onCompanyChange={handleApi}
          handleSort={handleSort}
        />
        <Box sx={styles.fromTogrid}>
          <Box sx={{ mx: 2.5 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={["DatePicker", "DatePicker"]}
                sx={styles.calender}
              >
                <DatePicker
                  label="From"
                  value={fromDate}
                  format={getDateFormat()}
                  onChange={(e) => {
                    setFromDate(e);
                  }}
                  sx={styles.calenderInput}
                  slotProps={{
                    field: {
                      readOnly: true,
                    },
                  }}
                />
                <DatePicker
                  label="To"
                  value={toDate}
                  format={getDateFormat()}
                  minDate={fromDate}
                  sx={styles.calenderInput}
                  slotProps={{
                    field: {
                      readOnly: true,
                    },
                  }}
                  onChange={(newValue) => {
                    setToDate(newValue);
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Box>
          <Box sx={styles.statusBtn}>
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              {status}
              <ArrowDropDownIcon />
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem onClick={() => handleStatus("All")}>All</MenuItem>
              <MenuItem onClick={() => handleStatus("Leave")}>Leave</MenuItem>
              <MenuItem onClick={() => handleStatus("Present")}>
                {" "}
                Present{" "}
              </MenuItem>
            </Menu>
          </Box>
        </Box>
        <AttendanceList
          data={data}
          handleDelete={handleDelete}
          page={page}
          total={total}
          setPage={setPage}
          permission={hasEditAllPermission || role === "Admin" || role === "SuperAdmin"}
          markAbsent={markAbsent}
        />
      </Box>

      <Modal
        open={open}
        setOpen={setOpen}
        disabled={noSelection || !checkInTime || Boolean(error) || groupLoading}
        setEmployeeData={setEmployeeData}
        loading={groupLoading}
        title="Attendance Details"
        handleCheck={handleAttendance}
        btnText={groupResult ? undefined : from === "checkIn" ? "Check In" : "Check Out"}
      >
        {groupResult && <GroupResultView result={groupResult} isCheckIn={from === "checkIn"} />}
        {!groupResult && (
        <>
        <Box>
          {!isPreAttendance && (
            <>
              <InputLabel sx={styles.label}>Cost Centre</InputLabel>
              <Select
                value={costCentre}
                onChange={(e) => handleCostCentre(e.target.value)}
                displayEmpty
                disabled={costCentreLoading}
                sx={{ ...styles.modalInput, ...styles.inputSpace }}
              >
                <MenuItem value="">
                  <em>Select</em>
                </MenuItem>
                <MenuItem value="All">All</MenuItem>
                {departments.map((d) => (
                  <MenuItem key={d._id || d.name} value={d.name}>
                    {d.name}
                  </MenuItem>
                ))}
              </Select>

              <Autocomplete
                id="autocomplete"
                multiple
                disableCloseOnSelect
                options={EmployeeData || []}
                value={selectedEmployees}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                filterOptions={(options) => options}
                getOptionLabel={(option) =>
                  option?.personalInfo?.email || option?.employee?.personalInfo?.email || ""
                }
                onInputChange={(event, newInputValue, reason) => {
                  if (reason === "input") handleAttendanceSearch(from, newInputValue);
                }}
                onChange={(event, newValue) => setSelectedEmployees(newValue)}
                renderOption={(props, option, { selected }) => {
                  const info = option?.personalInfo || option?.employee?.personalInfo || {};
                  return (
                    <li {...props}>
                      <Checkbox checked={selected} sx={{ mr: 1 }} />
                      <img
                        src={info.image || male}
                        alt="employee"
                        style={{ width: 36, height: 36, borderRadius: "50%", marginRight: 8 }}
                      />
                      <Box>
                        <Typography>{`${info.firstName || ""} ${info.surName || ""}`}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          {info.email}
                          {info.department ? ` · ${info.department}` : ""}
                        </Typography>
                      </Box>
                    </li>
                  );
                }}
                renderTags={(value, getTagProps) => {
                  const maxChips = 2;
                  const more = value.length - maxChips;
                  return [
                    ...value.slice(0, maxChips).map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option._id}
                        size="small"
                        label={option?.personalInfo?.email || option?.employee?.personalInfo?.email || ""}
                        sx={{ maxWidth: 150, m: 0.5, backgroundColor: "#E5E5E5", color: "#000" }}
                      />
                    )),
                    more > 0 && (
                      <Chip
                        key="more"
                        size="small"
                        label={`+${more} more`}
                        sx={{ m: 0.5, backgroundColor: "#E5E5E5", color: "#000" }}
                      />
                    ),
                  ];
                }}
                renderInput={(params) => (
                  <>
                    <InputLabel sx={styles.label}>{"Employee Email"}</InputLabel>
                    <TextField
                      {...params}
                      sx={{ ...styles.modalInput, ...styles.inputSpace }}
                      variant="outlined"
                      placeholder={selectedEmployees.length === 0 ? "Search and select employees" : ""}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loading || costCentreLoading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  </>
                )}
              />
              {skippedAutomatic > 0 && costCentre !== "" && (
                <Typography sx={{ fontSize: 12.5, color: "#777", mb: 1 }}>
                  {skippedAutomatic} employee(s) with attendance filled in automatically by schedule are not included.
                </Typography>
              )}
              {isGroupAction && (
                <Typography sx={{ fontSize: 12.5, color: "#777", mb: 1 }}>
                  Same time for all selected employees. Anyone who already has a record for a day is skipped, never
                  overwritten.
                </Typography>
              )}
            </>
          )}
        </Box>
        <Box sx={styles.containerInput}>
          <Box sx={{ mr: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <InputLabel sx={styles.label}>
                {from === "checkIn"
                  ? "Check In From Date"
                  : "Check Out From Date"}
              </InputLabel>
              <DatePicker
                value={checkinDate ? dayjs(checkinDate) : null}
                disabled={noSelection}
                onChange={(newValue) => {
                  const selectedDate = newValue ? newValue.format("YYYY-MM-DD") : null;
                  setCheckinDate(selectedDate);
                  if (checkinEndDate && selectedDate && !isGroupAction) {
                    handleCheckHoliday(selectedDate, checkinEndDate, holidayEmail, from);
                  }
                }}
                maxDate={dayjs()}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{ ...styles.modalInput, ...styles.width }}
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <InputLabel sx={styles.label}>
                {from === "checkIn" ? "Check In End Date" : "Check Out End Date"}
              </InputLabel>
              <DatePicker
                value={checkinEndDate ? dayjs(checkinEndDate) : null}
                disabled={noSelection}
                onChange={(newValue) => {
                  const selectedDate = newValue ? newValue.format("YYYY-MM-DD") : null;
                  setCheckinEndDate(selectedDate);
                  if (!isGroupAction) handleCheckHoliday(checkinDate, selectedDate, holidayEmail, from);
                }}
                // maxDate={dayjs()}
                minDate={checkinDate ? dayjs(checkinDate) : null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{ ...styles.modalInput, ...styles.width }}
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
        </Box>
        <FormControlLabel control={<Checkbox checked={includeNonScheduledDays} onChange={(e) => setIncludeNonScheduledDays(e.target.checked)} />} label="Include Non_Scheduled Days" />
        <Box>
          <InputLabel sx={styles.label}>
            {from === "checkIn" ? "Check In Time" : "Check Out Time"}
          </InputLabel>
          <TextField
            value={checkInTime}
            name="checkIn"
            disabled={noSelection}
            placeholder="hh:mm"
            defaultValue={checkInTime}
            onChange={(e) => handleChange(e.target.value, "time")}
            error={error}
            helperText={error}
            sx={{ ...styles.modalInput, ...styles.widths }}
          />
        </Box>

        <Box>
          <InputLabel sx={styles.label}>Note (Optional)</InputLabel>
          <TextField
            value={note}
            // label={from === "checkIn"?"Check In Time":"check Out Time"}
            // name="checkIn"
            disabled={noSelection}
            // placeholder="hh:mm"
            // defaultValue={checkInTime}
            onChange={(e) => setNote(e.target.value)}
            multiline
            rows={3}
            sx={{
              ...styles.modalInput,
              ...styles.noteInput,
              ...styles.inputSpace,
            }}
          />
        </Box>
        </>
        )}
      </Modal>

      <Modal
        open={opens}
        setOpen={setOpens}
        btnText={"Export"}
        title={"Export Attendance"}
        disabled={!email || !fromDates || !toDates || !type}
        handleCheck={applyRequest}
        loading={loading}
      >
        <Box sx={styles.containerInput}>
          <Box sx={{ width: "100%" }}>
            <InputLabel sx={styles.label}>Email Address</InputLabel>
            <TextField
              value={email}
              name="email"
              placeholder="Enter Email Address"
              onChange={handleEmailChange}
              error={!!emailError}
              helperText={emailError}
              sx={styles.modalInput}
            />
          </Box>
        </Box>
        <Box sx={styles.containerInput}>
          <Box sx={styles.datePickerContainer}>
            <InputLabel sx={{ ...styles.label, mb: 1, width: "100%" }}>From</InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={fromDates}
                slotProps={{
                  field: {
                    readOnly: true
                  }
                }}
                onChange={(newValue) => setFromDates(newValue)}
              />
            </LocalizationProvider>
          </Box>

          <Box sx={{ ...styles.datePickerContainer, ml: 1 }}>
            <InputLabel sx={{ ...styles.label, mb: 1, width: "100%" }}>To</InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={toDates}
                minDate={fromDates}
                sx={styles.calenderInput}
                onChange={(newValue) => setToDates(newValue)}
              />
            </LocalizationProvider>
          </Box>
        </Box>
        <Box>
          <InputLabel sx={{ ...styles.label, mt: 1, }}>Type</InputLabel>
          <Select
            value={type}
            onChange={(e) => setType(e.target.value)}
            name="type"
            sx={styles.modalInput}
            displayEmpty
          >
            <MenuItem disabled value="">
              Select
            </MenuItem>

            <MenuItem sx={styles.dropDownMenu} value="pdf">
              Pdf
            </MenuItem>
            <MenuItem sx={styles.dropDownMenu} value="csv">
              CSV
            </MenuItem>
          </Select>
        </Box>
      </Modal>

      <Modal
        open={importOpen}
        setOpen={setImportOpen}
        btnText={"Import"}
        title={"Import Attendance"}
        disabled={!img}
        handleCheck={() => applyFile(img)}
        loading={loading}
      >
        <Box>
          <Typography sx={styles.uploadText}>Upload File</Typography>
          <DragAndDropInput
            title="Import Attendance"
            handleUrl={(file) => {
              if (file && file.type === "text/csv") {
                setImg(file);
                setError("");
              } else {
                setImg(null);
                setError(
                  "Only CSV files are allowed. Please upload a valid CSV file."
                );
              }
            }}
          />
          {error && (
            <Typography sx={{ color: "red", fontSize: "14px", mt: "10px" }}>
              {error}
            </Typography>
          )}
        </Box>
      </Modal>

      <Modal open={holidayOpen} setOpen={setHolidayOpen} title={"Note"} loading={loading}>
        <Box>
          <Typography sx={styles.uploadText}>{popupMsg}</Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
            <Button variant="contained" color="primary" onClick={() => setHolidayOpen(false)}>
              Okay
            </Button>
            <Button variant="outlined" color="secondary" onClick={() => { setHolidayOpen(false), setOpen(false) }}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

    </>
  );
};

export default AttendancePage;
